import {useSelector} from "react-redux";
import {Outlet, useNavigate} from "react-router-dom";
import {useCookies} from "react-cookie";

export const ProtectRoutes = () => {
    const navigate = useNavigate();
    const [cookeis]=useCookies(["Authorization"])

    const data = useSelector((state) => state.hamberger);

    if (
        cookeis.Authorization === null ||cookeis.Authorization === undefined ||
        data.expireState === false
    ) {
        navigate("/login");
    } else {
        return <Outlet/>;
    }
};
